export default "__VITE_ASSET__r7Akb8jh__"